import {
    startOfMonth,
    endOfMonth,
    getYear,
    getMonth,
    format,
    eachWeekOfInterval,
    eachDayOfInterval,
    startOfISOWeek,
    endOfISOWeek,
    isSameMonth,
} from 'date-fns'

export const drawCalendar = (
    { year, month } = { year: getYear(new Date()), month: getMonth(new Date()) },
    convertDate = (day, { isSameMonth }) => (isSameMonth ? format(day, 'dd') : '--'),
) => {
    const date = new Date(year, month);

    const matrix = eachWeekOfInterval(
        {
            start: startOfMonth(date),
            end: endOfMonth(date),
        },
        { weekStartsOn: 1 },
    );

    return matrix.map(weekDay =>
        eachDayOfInterval({
            start: startOfISOWeek(weekDay),
            end: endOfISOWeek(weekDay),
        }).map(day =>
            convertDate(day, {
                isSameMonth: isSameMonth(date, day),
            }),
        ),
    );
};